var $treesmodal = YAHOO.namespace('TreesGlobalModal');

// Object for the trees modal
$treesmodal.TreesGlobalModal = function () { this.init(); };

$treesmodal.TreesGlobalModal.prototype =
{
	modalInitialized: false,
	modalPanelDiv: null,
	modalMaskDiv: null,

	init: function () {
		//If we don't exist in the dom for a page using this modal,
		//then we add the parent div set that is needed for this modal to function
		//The div set is:
		//<div id="mdlMsk" class="MdlMsk"></div>
		//<div id="mdlPnl" class="TreesMdlPnl"></div>
		this.modalPanelDiv = document.getElementById('mdlPnl');
		if (this.modalPanelDiv == null) {
			//get body tag
			var _body = document.getElementsByTagName('body')[0];

			var maskDiv = document.createElement("div");
			maskDiv.id = 'mdlMsk';
			maskDiv.className = "MdlMsk";
			this.modalMaskDiv = maskDiv;
			_body.appendChild(maskDiv);

			var panelDiv = document.createElement("div");
			panelDiv.id = 'mdlPnl';
			panelDiv.className = "TreesMdlPnl";
			this.modalPanelDiv = panelDiv;
			_body.appendChild(panelDiv);
		}

		if (typeof (document.getElementsByClassName) === 'undefined') {
			document.getElementsByClassName = function (name, tag, node) {
				var elmsToReturn = [];
				if (typeof (node) === 'undefined') {
					node = document;
				}
				else if (typeof (node) === typeof ('string')) {
					node = document.getElementById(node);
				}

				if (typeof (tag) === 'undefined') {
					tag = '*';
				}

				var elmsList = node.getElementsByTagName(tag);
				for (var a = 0; a < elmsList.length; a++) {
					if (elmsList[a].className) {
						var classesList = elmsList[a].className.split(' ');
						for (var b = 0; b < classesList.length; b++) {
							if (classesList[b] == name) {
								elmsToReturn.push(elmsList[a]);
								break;
							}
						}
					}
				}

				return (elmsToReturn);
			};
		}
	},

	initModal: function () {
		//Build Modal with Inner Content
		//		var modalPanelDiv = document.getElementById('ancMdlWrp');
		if (this.modalPanelDiv)
			this.modalPanelDiv.innerHTML = '<div class="PnlShdw rctl"></div><div class="PnlShdw rctr"></div><div class="PnlShdw rcbl"></div><div class="PnlShdw rcbr"></div><div class="PnlShdw htop"></div><div class="PnlShdw hbtm"></div><div class="PnlShdw vlft"></div><div class="PnlShdw vrgt"></div><div class="PnlShdw msec"></div><div id="mdlContent" class="PnlCont"></div>';
		this.modalInitialized = true;
	},

	centerModal: function (mdlId) {
		var modalToCenter = document.getElementById(mdlId), currH = 0, currW = 0;
		modalToCenter.style.display = 'block';
		currH = modalToCenter.offsetHeight;
		currW = modalToCenter.offsetWidth;
		if ((document.documentElement && Number(document.documentElement.clientHeight) !== 0 && document.documentElement.clientHeight < currH + 20) || (document.body.offsetHeight && document.body.offsetHeight < currH + 20) || (window.innerHeight && window.innerHeight < currH + 20)) {
			modalToCenter.style.position = 'absolute';
			modalToCenter.style.top = "20px";
			modalToCenter.style.marginTop = '0px';
			window.scroll(0, 0);
		} else {
			modalToCenter.style.position = 'fixed';
			modalToCenter.style.top = "50%";
			modalToCenter.style.marginTop = -(currH / 2) + 'px';
		}
		modalToCenter.style.left = "50%";
		modalToCenter.style.marginLeft = -(currW / 2) + 'px';
	},

	closeModal: function () {
		if (this.modalPanelDiv) {
			this.modalPanelDiv.style.display = 'none';
			this.modalMaskDiv.style.display = 'none';
		}
	},

	//we have the modal's inner content and a custom width for the modal (which could be a blank string "" if we
	// are setting the width of the modal somewhere else specifically in css)
	openModal: function (v_innerContent, modalWidth) {
		if (!this.modalInitialized) {
			this.initModal();
		}

		//set custom width
		if (this.modalPanelDiv && modalWidth != "")
			this.modalPanelDiv.style.width = modalWidth;

		document.getElementById('mdlMsk').style.display = 'block';
		var mdlContent = document.getElementById('mdlContent');
		mdlContent.innerHTML = "";
		mdlContent.innerHTML = v_innerContent;
		this.centerModal('mdlPnl');
	}
};

// Create the singleton if it doesn't exist
$treesmodal.TreesGlobalModalCreate = function () {
	if ('undefined' === typeof ($treesmodal.tgModal)) {
		$treesmodal.tgModal = new $treesmodal.TreesGlobalModal();
	}
};
//Trees function for uniformly setting up an Acom Global FED modal 
//by allowing a single create call with a set of params to handle things.
//Also this code allows us to update more easily if the Global FED group changes the modal
var $genTreesModal = {
	Modal: $('#modalDLG'),
	Params: null,
	spinnerCnt: "<div class='loading' style='margin:50px;'></div>",
	TitleName: '',
	//Initialize the dialog, this creates the container, content container, and the spinner, along with the Global modal call with a supplied width and title (which can be empty if we have one set in the html)
	//Params: id, width (width of modal), title (which shows as the title on the modal, empty string for none)
	init: function (id, width, title, datatitlename, modalEvents) {

		//var titleVal = $('#modalTitle').data(datatitlename);
		$genTreesModal.TitleName = datatitlename;
		$("<div class=\"modalHasTitle\"><header class=\"modalHeader\" id=\"modalHeader\"><h4 class=\"modalTitle\"></h4></header><div data-title='' id='" + id + "'><div id='" + id + "Content'>" + $genTreesModal.spinnerCnt + "</div></div></div>").modal({
			hideCloseBtn: false,
			closeOnBkgClick: true,
			closeOnEscape: true,
			isMarketing: false,
			showLoading: false,
			width: width,
			title: '',
			onOpen: modalEvents && modalEvents.onOpen ? modalEvents.onOpen : function () { },
			onClose: modalEvents && modalEvents.onClose ? modalEvents.onClose : function () { }
		});
	},
	//Create the modal content
	//Params: id, url (route for getting content - other options: this is '0' if htmlSrc is the full html, null if htmlSrc is the id to get html), htmlSrc(if we are providing the html then the id of the container is supplied, or the full html, otherwise if are using a url then we use null)
	// callback is the callback js function to call on success
	create: function (id, url, htmlSrc, callback) {
	    //Do we have html supplied directly
	    if (url != null && url == '0' && htmlSrc != null && htmlSrc.length > 0) {
			$genTreesModal.getView(id, htmlSrc);
			//For this type of modal, the title is part of the html, so hide global modal header area
			$('#modalHeader').hide();
			if (callback != null) {
				callback();
			}
			
			return true;
	    }
		//Do we have an html source supplied to grab html
	    else if (htmlSrc != null && htmlSrc.length > 0) {
			var htmlSrcGet = $('#' + htmlSrc);
			if (htmlSrcGet) {
				$genTreesModal.getView(id, htmlSrcGet.html());
				//For this type of modal, the title is part of the html, so hide global modal header area
				$('#modalHeader').hide();
				if (callback != null) {
					callback();
				}
			}
	    }
	    else { //get html from source via ajax
			$.ajax({
				url: url,
				cache: false,
				timeout: 20000,
				type: "GET",
				data: { params: $genTreesModal.Params },
				success: function (data) {
				    //If the view model throws an exception, we want to use the variable from the view and not have the view error out
				    if (typeof data.hasexception != 'undefined' && data.hasexception != null && data.hasexception) {
				        $genTreesModal.throwException(id, "view has thrown an exception!");
				    }

				    //Temporarily hide the title header area
				    $('#modalHeader').hide();

				    //Deal with different data returns, some use an html property, some have the first in a list, and others the direct data
				    var result = (data.html != null && data.html.length > 0) ? data.html : (((typeof data[0] != 'undefined') && data[0].length > 1) ? data[0] : data);
				    $genTreesModal.getView(id, result);
				    var modalCont = $('#modal');
				    if (modalCont.length > 0) {
				        modalCont.show();
				    }

				    //Set title
				    var modalTitle = $('#modalTitle');
				    if (modalTitle.length > 0 && $genTreesModal.TitleName.length > 0) {
				        var titleVal = modalTitle.data($genTreesModal.TitleName);
				        $('#modalHeader .modalTitle').text(titleVal);
				        $('#modalHeader').show();
						// $.modal.title(titleVal);
				    }

				    if (callback != null) {
				        callback();
				    }
				},
				error: function (xhr, ajaxOptions, thrownError) {
				    $genTreesModal.throwException(id, 'source->' + id + ' status->' + xhr.status + ' thrownError->' + thrownError);
				}
			});
		}
	},
	//Setting the content container inner html
	getView: function (id, html) {
	    if (html == null || html.responseText == "fail") {
		    $genTreesModal.throwException(id, html);
		}
		else {
		    if (html != null && html.length > 0) {
		        //Set the Modal contents
		        var $callouts = $("#" + id + "Content")
					.html(html)
					.find('[data-callout]');
		        if (typeof ($callouts.callout) != 'undefined' && $callouts.length > 0) {
		            $callouts.callout();
		        }
		    }
		}
	},
	throwException: function (id, msg) {
	    if (window.console != null) {
	        console.error(msg);
	    }
		//Make sure we display the check back soon
		$.ajax({
		    url: $trees.util.getAjaxUrlPrefix() + '/pt/Down.aspx?noHeaderFooter=1',
			cache: false,
			timeout: 20000,
			type: "GET",
			data: {},
			success: function (data) {
			    //For some reason this does NOT work on international sites, the page reloads to a blank page,
			    //the html() jQuery function only works in US, so for now we are using the old javascript method of setting the internal html
			    //    $("#" + id).html(data);

			    var modalcontent = document.getElementById(id);
			    modalcontent.innerHTML = data;
			}
		});
	}
};